// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict';

import axios from 'axios';
import { apiURL } from "@/app.config";

const HTTP = axios.create({
  baseURL: apiURL
//  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
});

export default HTTP;
